
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/snake-skin",
      function () {
        return require("private-next-pages/archive/snake-skin.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/snake-skin"])
      });
    }
  